export const MESSAGE_CONSTANT = {
    DATA_SAVED: 'Data Saved Successfully!!!',
    IMAGE_UPLOADED: 'Image update successfully!!!',
    IMAGE_DELETED: 'Image delete successfully!!!',
    SOMETHING_WRONG: 'Something went wrong!!!',
    UNAUTHORIZED: 'Partner not authorized',
    OTP_SENT: 'OTP sent successfully!',
    OTP_RESEND: 'OTP resent successfully!',
}